import { FC } from 'react';
import { User } from '@oresundsbron/icons';

export const UsernamePasswordIcon: FC<{
  height?: string;
  width?: string;
}> = ({ height = '3em', width = '3em' }) => {
  return <User height={height} width={width} />;
};
